import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: contents;
}

.hn-desktop-header {
  -webkit-backdrop-filter: blur(18px);
  backdrop-filter: blur(18px);
  background: radial-gradient(circle at 8% -100%, rgba(169, 201, 92, 0.12), transparent 240px), rgba(20, 24, 19, 0.97);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  color: #fff;
  height: 100%;
}

.hn-desktop-header__inner {
  align-items: center;
  display: grid;
  gap: clamp(12px, 1.8vw, 26px);
  grid-template-columns: minmax(160px, 1fr) auto minmax(160px, 1fr);
  height: 100%;
  margin: 0 auto;
  max-width: 1460px;
  padding: 0 clamp(18px, 2.2vw, 32px);
  width: 100%;
}

.hn-wordmark {
  align-items: center;
  color: #fff;
  display: flex;
  gap: 9px;
  justify-self: start;
  min-height: 40px;
  text-decoration: none;
}

.hn-wordmark__mark {
  background-color: var(--hn-accent);
  background-image: url("/assets/brand/hannom-mark-96.webp");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 9px;
  box-shadow: inset 0 0 0 1px rgba(18, 21, 18, 0.12);
  flex: 0 0 34px;
  height: 34px;
  width: 34px;
}

.hn-wordmark__copy strong,
.hn-wordmark__copy small {
  display: block;
}

.hn-wordmark__copy strong {
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0.115em;
  line-height: 1;
}

.hn-wordmark__copy small {
  color: rgba(255, 255, 255, 0.45);
  font-size: var(--hn-text-caption);
  font-weight: 650;
  letter-spacing: 0.02em;
  margin-top: 5px;
}

.hn-primary-nav {
  align-items: center;
  display: flex;
  gap: 2px;
  justify-self: center;
}

.hn-primary-nav__link {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 9px;
  color: rgba(255, 255, 255, 0.62);
  display: inline-flex;
  font-size: 14px;
  font-weight: 750;
  gap: 8px;
  min-height: 40px;
  padding: 0 12px;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 0.16s var(--hn-ease), border-color 0.16s var(--hn-ease), color 0.16s var(--hn-ease), transform 0.16s var(--hn-ease);
}

.hn-primary-nav__link:hover {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.9);
  transform: translateY(-1px);
}

.hn-primary-nav__link.is-active {
  background: rgba(169, 201, 92, 0.16);
  border-color: rgba(169, 201, 92, 0.22);
  color: #f0f8df;
}

.hn-primary-nav__icon {
  align-items: center;
  display: inline-flex;
  font-size: 14px;
  height: 18px;
  justify-content: center;
  width: 18px;
}

.hn-primary-nav__link.is-active .hn-primary-nav__icon {
  color: var(--hn-accent);
}

.hn-account-link {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 9px;
  color: #fff;
  display: inline-flex;
  gap: 9px;
  justify-self: end;
  min-height: 40px;
  padding: 4px 9px 4px 5px;
  text-decoration: none;
  transition: background-color 0.16s var(--hn-ease), border-color 0.16s var(--hn-ease);
}

.hn-account-link:hover,
.hn-account-link.is-active {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.09);
}

.hn-account-link__avatar {
  align-items: center;
  background: var(--hn-accent);
  border-radius: 9px;
  color: var(--hn-accent-ink);
  display: flex;
  font-size: 13px;
  font-weight: 900;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.hn-account-link__copy {
  min-width: 0;
}

.hn-account-link__copy strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hn-account-link__copy strong {
  font-size: 13px;
}

.hn-mobile-topbar,
.hn-mobile-nav {
  display: none;
}

.hn-desktop-header a:focus-visible {
  outline-color: var(--hn-accent);
}

@media (max-width: 1120px) and (min-width: 901px) {
  .hn-desktop-header__inner {
    gap: 12px;
    grid-template-columns: auto 1fr auto;
    padding: 0 24px;
  }
  .hn-wordmark__copy small {
    display: none;
  }
  .hn-primary-nav__link {
    padding: 0 10px;
  }
}
@media (max-width: 1020px) and (min-width: 901px) {
  .hn-wordmark__copy,
  .hn-account-link__copy {
    display: none;
  }
  .hn-primary-nav__link {
    gap: 6px;
    padding: 0 9px;
  }
}
@media (max-width: 900px) {
  .hn-desktop-header {
    display: none;
  }
  .hn-mobile-topbar {
    align-items: center;
    background: rgba(17, 21, 15, 0.97);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    display: flex;
    height: 54px;
    justify-content: flex-start;
    padding: 0 16px;
  }
  .hn-mobile-brand {
    align-items: center;
    color: #fff;
    display: inline-flex;
    gap: 10px;
    text-decoration: none;
  }
  .hn-mobile-brand .hn-wordmark__mark {
    border-radius: 10px;
    flex-basis: 32px;
    height: 32px;
    width: 32px;
  }
  .hn-mobile-brand strong {
    font-size: 14px;
    font-weight: 900;
    letter-spacing: 0.12em;
  }
  .hn-mobile-nav {
    -webkit-backdrop-filter: blur(18px);
    backdrop-filter: blur(18px);
    background: rgba(255, 255, 255, 0.96);
    border-top: 1px solid rgba(18, 21, 16, 0.11);
    bottom: 0;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    left: 0;
    padding: 0 4px env(safe-area-inset-bottom);
    position: fixed;
    right: 0;
    z-index: 60;
  }
  .hn-mobile-nav a {
    align-items: center;
    color: #667064;
    display: flex;
    flex-direction: column;
    gap: 5px;
    justify-content: center;
    min-height: 60px;
    min-width: 0;
    position: relative;
    text-decoration: none;
    transition: color 0.16s var(--hn-ease);
  }
  .hn-mobile-nav a::before {
    background: var(--hn-accent-deep);
    border-radius: 0 0 4px 4px;
    content: "";
    height: 3px;
    left: 32%;
    opacity: 0;
    position: absolute;
    right: 32%;
    top: 0;
    transform: scaleX(0.35);
    transition: opacity 0.16s var(--hn-ease), transform 0.2s var(--hn-ease);
  }
  .hn-mobile-nav a strong {
    font-size: var(--hn-text-caption);
    font-weight: 700;
    line-height: 1;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hn-mobile-nav .hn-icon {
    font-size: 17px;
  }
  .hn-mobile-nav a.is-active {
    color: #3f5714;
  }
  .hn-mobile-nav a.is-active::before {
    opacity: 1;
    transform: scaleX(1);
  }
}`],
})
export class ComponentNavSidebarComponent {
    public menuItems: any[] = [
        { path: '/dashboard', label: '운용 현황', shortLabel: '현황', icon: 'fa-chart-simple' },
        { path: '/target', label: '종목 선택', shortLabel: '종목', icon: 'fa-crosshairs' },
        { path: '/history', label: '거래 기록', shortLabel: '기록', icon: 'fa-clock-rotate-left' },
        { path: '/settings', label: '설정', shortLabel: '설정', icon: 'fa-sliders' },
        { path: '/mypage', label: '내 정보', shortLabel: '내 정보', icon: 'fa-user', account: true }
    ];

    public primaryMenuItems: any[] = this.menuItems.filter((item) => !item.account);
    public accountMenuItem: any = this.menuItems.find((item) => item.account);

    constructor(@Inject( Service) public service: Service) { }

    public isActive(link: string) {
        return location.pathname === link || location.pathname.indexOf(link + '/') === 0;
    }
}

export default ComponentNavSidebarComponent;